import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import KairosLogo from './KairosLogo';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  };

  const footerLinks = [
    { label: 'Philosophie', href: '/#philosophie' },
    { label: 'Approche', href: '/#approche' },
    { label: 'Expertises', href: '/#expertises' },
    { label: 'Tarifs', href: '/tarifs' },
    { label: 'Contact', href: '/#contact' },
  ];

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    if (link.href.startsWith('/#')) {
      if (location.pathname === '/') {
        const el = document.querySelector(link.href.replace('/', ''));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(link.href);
      }
    } else {
      navigate(link.href);
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  };

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-[5%] py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <motion.a
            href="/"
            onClick={handleLogoClick}
            className="interactive"
            whileHover={{ scale: 1.02 }}
          >
            <KairosLogo size="sm" animated={false} />
          </motion.a>

          <nav className="flex flex-wrap justify-center gap-6">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleLinkClick(e, link)}
                className="text-[#555] text-sm hover:text-[#888] transition-colors interactive"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <p className="text-[#555555] text-sm">
            © {currentYear} KAIROS
          </p>
        </div>

        <motion.div
          className="flex justify-center mt-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="flex items-center gap-3">
            <motion.div
              className="w-12 h-px bg-[#333333]"
              initial={{ width: 0 }}
              whileInView={{ width: 48 }}
              transition={{ duration: 0.5 }}
            />
            <motion.div
              className="w-1.5 h-1.5 bg-[#2A3B8F] rotate-45"
              animate={{ rotate: [45, 405] }}
              transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
            />
            <motion.div
              className="w-12 h-px bg-[#333333]"
              initial={{ width: 0 }}
              whileInView={{ width: 48 }}
              transition={{ duration: 0.5 }}
            />
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
